import { Link } from "react-router"

import logoUrl from "@/assets/branding/nha-cam-logo.png"

export const HeaderLogo = () => (
  <Link
    to="/"
    aria-label="Nhà Cam Homestay - về trang chủ"
    className="shrink-0 rounded-md focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-current"
  >
    <img
      src={logoUrl}
      alt="Nhà Cam Homestay"
      className="h-10 w-[88px] rounded-md object-cover shadow-sm sm:h-11 sm:w-24 lg:h-12 lg:w-[104px]"
    />
  </Link>
)

